export default "__VITE_ASSET__CiON80kV__"